export default __webpack_public_path__ + "8a2f241fe239f10d9c6e3ac148293138.jpg";